document.addEventListener("alpine:init", () => {
  Alpine.data('productVariantSelector', (variants, initial) => ({
    variants: variants,
    selected_variant: initial.selected_variant,
    available: initial.available,
    dispatch_date: initial.dispatch_date,
    price: initial.price,
    compare_at_price: initial.compare_at_price,
    option1: initial.option1,
    option2: initial.option2,
    option3: initial.option3,
    featured_image_src: initial.featured_image_src,
    featured_image_id: initial.featured_image_id,

    init: function () {
      this.$nextTick(() => {
        const popular = this.variants.find((v) => v.most_popular && v.available);
        if (popular) {
          this.option1 = popular.option1;
          this.option2 = popular.option2;
          this.option3 = popular.option3;
        }
        this.updateVariant();
      });
    },

    updateVariant: function () {
      for (var i = 0; i < this.variants.length; i++) {
        let variant = this.variants[i];
        if (
          variant.option1 === this.option1 &&
          variant.option2 === this.option2 &&
          variant.option3 === this.option3
        ) {
          this.selected_variant = variant.id;
          this.available = variant.available;
          this.dispatch_date = variant.dispatch_date;
          this.price = variant.price;
          this.compare_at_price = variant.compare_at_price;
          this.featured_image_src = variant.featured_image_src;
          this.featured_image_id = variant.featured_image_id;

          const urlParams = new URLSearchParams(window.location.search);
          urlParams.set("variant", variant.id);
          const newUrl = `${window.location.pathname}?${urlParams.toString()}${window.location.hash}`;
          window.history.replaceState({}, "", newUrl);

          this.$dispatch("variant-updated", { variant: variant });

          if (this.$refs.dispatch_date) {
            if (this.dispatch_date != "") {
              this.$refs.dispatch_date.setAttribute("name", "properties[Dispatch date]");
            } else {
              this.$refs.dispatch_date.setAttribute("name", "");
            }
          }

          const element = document.querySelector(`[data-media-id="${this.featured_image_id}"]`);
          if (element) {
            const index = Array.from(element.parentNode.children).indexOf(element);
            const navButton = document.querySelector("carousel-navigation").children[index];
            navButton.click();
          }

          break;
        }
      }
    },
  }));

  Alpine.data('productForm', (initial) => ({
    quantity: 1,
    id: initial.id,
    addons: [],

    submitForm: function () {
      let itemsToAdd = [
        {
          id: this.id,
          quantity: this.quantity,
        },
      ];

      this.addons.forEach((addonId) => {
        itemsToAdd.push({
          id: addonId,
          quantity: 1,
        });
      });

      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          items: itemsToAdd,
        }),
      })
        .then((response) => {
          if (!response.ok) throw new Error('Add to cart failed');
          return fetch('/cart.js');
        })
        .then((response) => response.json())
        .then((cartJson) => {
          this.$dispatch('cart:refresh', {
            cart: cartJson,
          });
          this.$dispatch('toggle-cart-drawer');
          this.addons = [];
        })
        .catch((error) => {
          alert('Error: please try again');
          console.error('Error:', error);
        });
    },
  }));

  Alpine.data('countdownTimer', (expiry) => ({
    expiry: new Date(expiry).getTime(),
    remaining: null,

    init() {
      this.setRemaining();
      setInterval(() => {
        this.setRemaining();
      }, 1000);
    },

    setRemaining() {
      const now = new Date().getTime();
      const diff = this.expiry - now;
      this.remaining = parseInt(diff / 1000);
    },

    days() {
      return {
        value: Math.floor(this.remaining / 86400),
        remaining: this.remaining % 86400,
      };
    },

    hours() {
      return {
        value: Math.floor(this.days().remaining / 3600),
        remaining: this.days().remaining % 3600,
      };
    },

    minutes() {
      return {
        value: Math.floor(this.hours().remaining / 60),
        remaining: this.hours().remaining % 60,
      };
    },

    seconds() {
      return {
        value: this.minutes().remaining,
      };
    },

    format(value) {
      return ('0' + parseInt(value)).slice(-2);
    },

    time() {
      return {
        days: this.format(this.days().value),
        hours: this.format(this.hours().value),
        minutes: this.format(this.minutes().value),
        seconds: this.format(this.seconds().value),
      };
    },
  }));

  Alpine.data('klaviyoSignupForm', () => ({
    success_message: 'Thanks! We will let you know when this product is available to purchase.',
    failed_message: 'Sorry, an error occured. Please try again.',
    result: null,
    submit: {
      ['@submit.prevent']() {
        const action = this.$el.getAttribute('action');

        const config = {
          method: 'POST',
          headers: {
            'Access-Control-Allow-Headers': '*',
            'Content-Type': 'application/x-www-form-urlencoded; charset=utf-8',
          },
          body: new URLSearchParams(new FormData(this.$el)),
        };

        return fetch(action, config)
          .then((response) => response.json())
          .then((response) => {
            this.result = response.success;
            this.$refs.email.value = '';
            setTimeout(() => {
              this.result = null;
            }, 5000);
          })
          .catch((err) => console.error(err));
      },
    },
  }));

  Alpine.data('neckSizeSelector', () => ({
    sizeKey: 'average',
    sizeData: null,
    modelHeight: null,
    sizeImages: [],

    updateSizeImage: function () {
      if (!this.selected_variant || !this.sizeKey) {
        this.sizeData = null;
        this.modelHeight = null;
        return;
      }
      const variantData = this.sizeImages.find((v) => v.id === this.selected_variant);
      if (variantData) {
        this.modelHeight = variantData.model_height;
        this.sizeData = variantData[this.sizeKey];
      } else {
        this.sizeData = null;
        this.modelHeight = null;
      }
    },

    init: function () {
      try {
        this.sizeImages = JSON.parse(this.$refs.sizeImages.innerHTML);
      } catch (e) {
        console.error('Failed to parse sizeImages JSON:', e);
      }
      this.updateSizeImage();
      this.$watch('selected_variant', () => this.updateSizeImage());
    },
  }));

  Alpine.data('productStickyBar', (initial) => ({
    show: false,
    selected_variant: initial.selected_variant,
    available: initial.available,
    dispatch_date: initial.dispatch_date,
    price: initial.price,
    compare_at_price: initial.compare_at_price,

    onVariantUpdated: function (event) {
      const variant = event.detail.variant;
      this.selected_variant = variant.id;
      this.available = variant.available;
      this.dispatch_date = variant.dispatch_date;
      this.price = variant.price;
      this.compare_at_price = variant.compare_at_price;
      if (this.dispatch_date != '') {
        this.$refs.dispatch_date.setAttribute('name', 'properties[Dispatch date]');
      } else {
        this.$refs.dispatch_date.setAttribute('name', '');
      }
    },
  }));

  Alpine.data('scrollArrows', () => ({
    showLeftArrow: false,
    showRightArrow: false,

    updateArrows() {
      const slider = this.$refs.slider;
      if (!slider) return;
      this.showLeftArrow = slider.scrollLeft > 0;
      this.showRightArrow = Math.ceil(slider.scrollLeft) < slider.scrollWidth - slider.clientWidth;
    },
  }));
});
